export const popupFocusFirstInput = {
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
    initializePopupMutationObserver () {
      setTimeout(() => {
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutationRecord) {
            if (mutationRecord.target.style.display === 'none') {
            } else {
              const firstInputElement = mutationRecord.target.querySelectorAll('input')[0]
              if (
                firstInputElement.parentElement.className !==
                'vs__selected-options'
              ) firstInputElement.focus()
            }
          })
        })

        const allPopup = document.getElementsByClassName('con-vs-popup')
        // const allPopup = document.querySelectorAll('.con-vs-popup, .vs-popup')
        allPopup.forEach((ele, key) => {
          const target = ele
          observer.observe(target, {
            attributes: true,
            attributeFilter: ['style']
          })
        })
      }, 100)
    }
  }
}
